import { render } from "./LdapTestConnectionModal.vue?vue&type=template&id=7b76f5a0&scoped=true"
import script from "./LdapTestConnectionModal.vue?vue&type=script&lang=js"
export * from "./LdapTestConnectionModal.vue?vue&type=script&lang=js"

import "./LdapTestConnectionModal.vue?vue&type=style&index=0&id=7b76f5a0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b76f5a0"]])

export default __exports__